var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"location"},[_c('span',[_vm._v(_vm._s(_vm.item.text))]),_c('Checkbox',{attrs:{"value":_vm.chosen,"dense":"","class-name":"mt-0 ml-2 pt-0"},on:{"input":function($event){return _vm.handleAssigning($event)}}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }